module.exports = __webpack_public_path__ + "static/media/carAdvise_autoglass.50111295.svg";